// src/features/landing/presentation/pages/AboutPage.jsx
import React from "react";
import { BrandStorySection } from "../components/BrandStorySection";
import { BrokerageIntroSection } from "../components/BrokerageIntroSection";
import { CompanyQASection } from "../components/CompanyQASection";
import { Footer } from "../components/Footer";

import "../styles/landing.css";
import {StrengthSection} from "../components/StrengthSection";
import { RbBridgeAboutSection } from "../components/RbBridgeAboutSection";

export function AboutPage() {
    return (
        <>
            <div style={{ paddingTop: '40px' }}>
                <BrandStorySection />
                <BrokerageIntroSection />
                <CompanyQASection />
                <RbBridgeAboutSection />
                <StrengthSection />
            </div>
            <Footer />
        </>
    );
}
